import { ANALYTICS_EVENT } from '../analytics/types';
import * as types from './types';

export const apiEventsLatestRequest = (id) => ({
  type: types.EVENTS_LATEST.REQUEST,
  payload: {
    id,
  },
});

export const apiEventsShowRequest = (id) => ({
  type: types.EVENTS_SHOW.REQUEST,
  payload: {
    id,
  },

  meta: {
    analytics: {
      type: ANALYTICS_EVENT,
      payload: {
        hitType: 'event',
        eventCategory: 'Events',
        eventAction: 'show',
        eventLabel: id,
      },
    },
  },
});

export const apiEventsTicketsRequest = (id, params) => ({
  type: types.EVENTS_TICKETS.REQUEST,
  payload: {
    id,
    params,
  },
});

export const apiEventsTicketsCuratedRequest = (id, params) => ({
  type: types.EVENTS_TICKETS_CURATED.REQUEST,
  payload: {
    id,
    params,
  },
});



// WEBPACK FOOTER //
// ./src/actions/events/actions.js